import React, { Component } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Slide,
  Paper,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import { connect } from 'react-redux';

import Draggable from 'react-draggable';

import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';

import NettingDuck from '../../../ducks/NettingDuck';
import WalletsDuck from '../../../ducks/WalletsDuck';
import { openSnackbar } from '../../../components/Notifier';

const styles = (theme) => ({
  prompt: {
    marginBottom: theme.spacing.unit,
  },
  formControl: {
    marginBottom: theme.spacing.unit,
  },
});

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

function PaperComponent(props) {
  return (
    <Draggable>
      <Paper {...props} />
    </Draggable>
  );
}

class NettingDialog extends Component {
  render() {
    const { classes } = this.props;
    return (
      <Dialog
        open={this.props.open}
        TransitionComponent={Transition}
        PaperComponent={PaperComponent}
        aria-labelledby="Netting"
        onClose={this.handleClose}
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle id="form-dialog-title">Netting</DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.prompt}>
            Please review the netting result and click Clearing to initiate
            clearing transactions:
          </DialogContentText>
          <JSONPretty data={this.props.nettingResult}></JSONPretty>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClose} color="default">
            Cancel
          </Button>
          <Button onClick={this.startClearing} color="primary">
            Clearing
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  handleClose = () => {
    this.props.hideNettingDialog();
  };

  startClearing = () => {
    const { token } = this.props;
    this.props
      .startClearing({ token })
      .then(({ value: virtualTransactions }) => {
        this.props.addVirtualTransactions({ virtualTransactions });
        this.props.hideNettingDialog();
        openSnackbar({ message: 'Clearing done!' });
      });
  };
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    nettingResult: state.netting.nettingResult,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideNettingDialog: () => {
      return dispatch(NettingDuck.creators.hideNettingDialog());
    },
    startClearing: ({ token }) => {
      return dispatch(WalletsDuck.creators.startClearing({ token }));
    },
    addVirtualTransactions: ({ virtualTransactions }) => {
      return dispatch(
        WalletsDuck.creators.addVirtualTransactions({ virtualTransactions }),
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(NettingDialog));
